<div>
  <div class="form-section">
    <form [formGroup]="locationDetailForm">
      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label for="country" class="required">Country</label>
            <select type="text" class="form-control" id="country" formControlName="country" (change)="onChangeCountry()">
              <option value="">Select Country</option>
              <option [value]="country.name" *ngFor="let country of countries$ | async">{{ country.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="state" class="required">State</label>
            <select type="text" class="form-control" id="state" formControlName="state" *ngIf="locationDetailForm.get('country').value == 'United States'; else stateinput">
              <option value="">Select State</option>
              <option [value]="state.name" *ngFor="let state of states$ | async">{{ state.name }}</option>
            </select>
            <ng-template #stateinput>
              <input type="text" class="form-control" id="state" formControlName="state">
            </ng-template>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="city" class="required">City</label>
            <input type="text" class="form-control" id="city" formControlName="city">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4" *ngIf="locationDetailForm.get('country').value == 'United States'">
          <div class="form-group">
            <label for="county" class="required">County</label>
            <input type="text" class="form-control" id="county" formControlName="county">
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="zip_code" class="required">Zip code</label>
            <input type="text" class="form-control" id="zip_code" formControlName="zip" mask="00000"/>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="address_line" class="required">Address Line</label>
            <input type="text" class="form-control" id="address_line" formControlName="address_line_1"/>
            <app-validation-error [control]="locationDetailForm.get('address_line_1')"></app-validation-error>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-12 mt-4 d-flex justify-content-between">
          <button class="btn text-dark-orange btn-link btn-md mr-1 text-decoration-none" (click)="addNewLocation()">Add New
            Location</button>
          <div>
            <button type="button" class="btn btn-outline-secondary btn-sm text-dark mr-1">
              Cancel
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm text-primary mr-1" (click)="saveLocation()">
              {{ editLocationIndex || editLocationIndex == 0 ? 'Update' : 'Save' }}
            </button>
            <button type="button" class="btn spear-button-background btn-sm text-white" (click)="onSubmitForm()">
              Save & Continue
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
